import { render, staticRenderFns } from "./NewWorkerAction.vue?vue&type=template&id=6a88d3b8&"
import script from "./NewWorkerAction.vue?vue&type=script&lang=js&"
export * from "./NewWorkerAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports